<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_ix">
<p class="ack"><b>Acknowledgements</b></p>
<p class="body-text">First and foremost to my dear friend Howard Sasportas, who is the father of this child; to Michele Ashmore, who lived through the first trimester with me; to Ean Begg, who conspired with my unconscious and walked with me through a dramatic and highly charged transition; to Melanie Reinhart, for her valued response to the first draft work; to Axel Harvey, for his faith in me and his astute observations and pointed questions on the first draft; to my soul-brother Jim Lewis, who has been with me now for fourteen years sharing dreams, ideas, support, love, black humour and friendship - phone bills from San Francisco to Victoria, then to London notwithstanding! Also to Robertson Davies.</p>
<p class="indent">To my far-flung and highly unconventional family: my brother Rob, for surviving and growing; my stepfather Bob, for standing by me in those times; my Uncle Tom, my surrogate Capricorn mother-father; my Capricorn mother, who died as I began this book; the Capricorn father of my children, Patrick Sullivan; and Kathy.</p>
<p class="indent">Last but not least to my ever-evolving animus (which, I suspect, is a Capricorn).</p>
</a></div><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?22efb835